import { createFileRoute } from '@tanstack/react-router'
import { CreateOrganizationPage } from '@/pages/profile/create-organization/ui/CreateOrganizationPage'

export const Route = createFileRoute('/organization-profile_/create')({
  component: CreateOrganizationPage,
})
